// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"c788ca5b","511":"20eef819","884":"d1350a7f","886":"603ddcc7"}[chunkId] + ".css";
};